/**
 * Words of the shell restyle (UI 0.16.0): the drawer groups by area and the
 * quick jump of the global search (Ctrl+K). Same two trees as the other
 * dictionary files, so `dict.test.ts` checks them like the rest.
 */
import type { DictNode } from './dict.js'

export const shellIt: DictNode = {
  navGroup: {
    content: 'Contenuti',
    structure: 'Struttura',
    planning: 'Pianificazione',
    settings: 'Impostazioni',
    client: 'Cliente',
  },
  jump: {
    screens: 'Vai a',
    shortcut: 'Scorciatoia: Ctrl+K',
    hint: 'Cerca contenuti o digita il nome di una schermata',
  },
}

export const shellEn: DictNode = {
  navGroup: {
    content: 'Content',
    structure: 'Structure',
    planning: 'Planning',
    settings: 'Settings',
    client: 'Client',
  },
  jump: {
    screens: 'Go to',
    shortcut: 'Shortcut: Ctrl+K',
    hint: 'Search content or type the name of a screen',
  },
}
